import { createApiClient } from './client'
import { API_BASE_URL, browserSession } from './session'

export * from './client'
export * from './csv'
export * from './errors'
export * from './format'
export * from './queryClient'
export * from './session'
export * from './types'

/**
 * Jediná inštancia klienta pre celú aplikáciu.
 *
 * Testy si vytvárajú vlastnú cez `createApiClient()` s podstrčeným `fetch`
 * a `session` — táto inštancia je viazaná na prehliadač.
 */
export const api = createApiClient({
	baseUrl: API_BASE_URL,
	session: browserSession,
})
